import { DateTime } from "luxon"
import { apiClientConfig, callApi } from "@/utils/api-utils"
import { EncounterApi } from "@vitable/asclepius-api-client-ts"
import store from "@/store"

const state = () => ({
  overdueEncountersCount: 0
})

const getters = {}

const actions = {
  async getOverdueEncountersCount({ commit }) {
    if (!store.getters["me/provider"]) throw new Error("Cannot get overdue Encounters for non-providers")

    let encounterApi = new EncounterApi(apiClientConfig())
    let request = {
      providerId: store.getters["me/provider"].id,
      missingHpi: true,
      endDatetime: DateTime.now().minus({ hours: 12 }).toString(),
      cancelled: false
    }

    try {
      const response = await callApi(() => encounterApi.listEncounters(request), this)
      commit("setOverdueEncountersCount", {
        count: response.count
      })
    } catch (e) {
      console.error(e)
      return e
    }
  }
}

const mutations = {
  setOverdueEncountersCount(state, { count }) {
    state.overdueEncountersCount = count
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
